import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import styles from './styles.module.scss';

import { PathnamesMap } from '../../constants/ui';
import { selectScrolledTimeline } from '../../store/slices/sensors';
import { Button } from '@cropler/ui-kit';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const PageSwipeMessage = ({ scrollRef }) => {
  const { prevSensor, nextSensor, selectedDate } = useSelector((state) => state.sensors);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickSensor = (id) => {
    if (id) {
      setTimeout(() => {
        navigate({
          pathname: `/${PathnamesMap.timeline}/${id}`,
          search: `?date=${selectedDate}`,
        });
        dispatch(selectScrolledTimeline(false));
      }, 50);
      setTimeout(() => {
        scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }, 150);
    }
  };

  return (
    <div className={`${styles.Message} ${!prevSensor || !prevSensor.id ? styles.MessageOne : ''}`}>
      {prevSensor && prevSensor.id && (
        <Button
          className={styles.MessageWrapper}
          type='secondary'
          onClick={() => onClickSensor(prevSensor.id)}
          icon={<CroplerIcon name="down" />}
        >
          {prevSensor.name && <span>{prevSensor.name}</span>}
        </Button>
      )}

      {nextSensor && nextSensor.id && (
        <Button
          className={styles.MessageWrapper}
          type='secondary'
          onClick={() => onClickSensor(nextSensor.id)}
          icon={<CroplerIcon name="down" />}
        >
          {nextSensor.name && <span>{nextSensor.name}</span>}
        </Button>
      )}
    </div>
  );
};

export default PageSwipeMessage;
